import React from 'react';
import { Bell } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface NotificationsDropdownProps {
  notifications: any[];
}

export default function NotificationsDropdown({ notifications }: NotificationsDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative text-white hover:bg-white/10 p-2 rounded-lg transition-all duration-300">
          <Bell className="w-5 h-5" />
          {notifications.length > 0 && (
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full text-xs flex items-center justify-center">
              {notifications.length}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <div className="p-3 border-b">
          <h3 className="font-semibold">Notifikasi</h3>
        </div>
        {notifications.length === 0 ? (
          <div className="p-4 text-center text-gray-500">Tidak ada notifikasi baru</div>
        ) : (
          notifications.map(notif => (
            <DropdownMenuItem key={notif.id} className="p-3 cursor-pointer">
              <div>
                <p className="font-medium text-sm">{notif.title}</p>
                <p className="text-xs text-gray-500">{notif.message}</p>
              </div>
            </DropdownMenuItem>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
